import { render, staticRenderFns } from "./group-bar.md?vue&type=template&id=2495bb9d&"
import script from "./group-bar.md?vue&type=script&lang=js&"
export * from "./group-bar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2495bb9d')) {
      api.createRecord('2495bb9d', component.options)
    } else {
      api.reload('2495bb9d', component.options)
    }
    module.hot.accept("./group-bar.md?vue&type=template&id=2495bb9d&", function () {
      api.rerender('2495bb9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Bar/group-bar.md"
export default component.exports